import { render, staticRenderFns } from "./titleIndex.vue?vue&type=template&id=db20c446"
import script from "./titleIndex.vue?vue&type=script&lang=ts"
export * from "./titleIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports